import { convertToEnglishNumbers } from "util/general";
import {
  DEFAULT_COUNTRY_ISO2,
  getCountryByIso2,
  getDefaultCountry,
  MENA_COUNTRIES,
} from "constants/countries";

/**
 * Detect country from an E.164 / international number via dial-code prefix.
 */
export const detectCountryIso2 = (phone) => {
  const digits = convertToEnglishNumbers(String(phone || ""))
    .replace(/^\+/, "")
    .replace(/^00/, "")
    .replace(/\D/g, "");

  const match = [...MENA_COUNTRIES]
    .sort((a, b) => b.dialCode.length - a.dialCode.length)
    .find((country) => digits.startsWith(country.dialCode));

  return match?.iso2;
};

/**
 * National digits only (no dial code / leading zeros).
 */
export const toNationalDigits = (phone, countryIso2 = DEFAULT_COUNTRY_ISO2) => {
  const detected = detectCountryIso2(phone);
  const country = getCountryByIso2(detected || countryIso2) || getDefaultCountry();
  let digits = convertToEnglishNumbers(String(phone || ""))
    .replace(/^\+/, "")
    .replace(/^00/, "")
    .replace(/\D/g, "");

  if (digits.startsWith(country.dialCode)) {
    digits = digits.slice(country.dialCode.length);
  }

  return digits.replace(/^0+/, "");
};

/**
 * Build E.164 for API payloads from national or international input.
 */
export const toApiPhoneNumber = (phone, countryIso2 = DEFAULT_COUNTRY_ISO2) => {
  const normalized = convertToEnglishNumbers(String(phone || "")).trim();
  if (!normalized) return "";

  if (normalized.startsWith("+") || normalized.startsWith("00")) {
    const digits = normalized.replace(/^\+/, "").replace(/^00/, "").replace(/\D/g, "");
    return `+${digits}`;
  }

  const country = getCountryByIso2(countryIso2) || getDefaultCountry();
  const national = toNationalDigits(normalized, country.iso2);
  return `+${country.dialCode}${national}`;
};
